$ = require 'jquery'
AppcuesNc = require 'network/appcues-nc'
Auth = require 'db/auth'
ClientVersion = require 'debug/client-version'
Controller = require 'controller'
Dialog = require 'views/lib/dialog'
HeaderAddMenuView = require 'views/header/header-add-menu-view'
HeaderChannelPicker = require 'views/header/header-channel-picker'
HeaderMemberMenuView = require 'views/header/header-member-menu-view'
HeaderEnterpriseAdminDashboardMenuView = require 'views/header/header-enterprise-admin-dashboard-menu-view'
HeaderNotificationListView = require 'views/notification/header-notification-list-view'
HeaderAppcuesPopOverComponent = require 'views/header/header-appcues-popover-component'
HeaderInfoMenuView = require 'views/header/header-info-menu-view'
MemberState = require 'view-models/member-state'
ModelLoader = require 'db/model-loader'
Notification = require 'models/notification'
PopOver = require 'views/lib/pop-over'
React = require 'react'
getExperiment = require 'lib/experiments/simple-test'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
l = require 'lib/localize'
log = require 'debug/log'
createBoardHelpers = require 'views/board-create/helpers'
track = require 'debug/track'

ClientConfig = require 'debug/client-config'

memberTemplate = require 'views/templates/member'
headerUser = require 'views/templates/header_user'
headerUserAnonymous = require 'views/templates/header_user_anonymous'

module.exports = class HeaderMemberView extends View

  className: 'header-user'

  initialize: ->
    if !Auth.isLoggedIn()
      return super
    @listenTo @modelCache, 'add:Notification change:Notification remove:Notification', @renderUnreadNotifications
    @listenTo @model, 'change:showNps change:marketingOptIn change:notificationsCount', @renderUnreadNotifications
    @listenTo @model, 'change:notificationsCount', @updateLastSeen
    @listenTo @model.notificationsSeenState, 'change:lastSeenNotificationGroup', @renderUnreadNotifications
    @listenTo @model, 'change:initials change:avatarHash change:avatarSource change:fullName change:username', @renderAvatar

    @appcuesItems = AppcuesNc.getItems Auth.myId()
    AppcuesNc.on 'appcuesUpdate', ((@appcuesItems) -> @render()), @

    super

  events:
    'click .js-open-inspiration-page': 'viewInspirationPage'
    'click .js-open-header-info-menu': 'viewInfoMenu'
    'click .js-open-header-appcues-menu': 'viewAppcuesMenu'
    'click .js-open-header-notifications-menu': 'viewNotificationsMenu'
    'click .js-open-enterprise-dashboard-menu': 'viewEnterpriseDashboardMenu'
    'click .js-open-header-member-menu': 'viewMemberMenu'
    'mouseenter .js-open-add-menu': 'preloadCreateBoardData'
    'click .js-open-add-menu': 'openAddMenu'
    'click .js-open-channel-picker': 'viewChannelPicker'

  render: ->
    log('render', 'rendering header')
    escapedReturnUrl = Util.escapedReturnUrl()
    if !Auth.isLoggedIn()
      @$el.html(headerUserAnonymous({ escapedReturnUrl }))
      return @

    hasAppcuesNews = !MemberState.getAppcuesOptOut() && @appcuesItems.some((item) -> !item.seen)
    if hasAppcuesNews
      track("Header", "Appcues Menu", "Display Appcues Menu")

    data =
      hasCrown: @model.isFeatureEnabled('crown')
      showChannelPicker:
        (@model.get('channels').allowed.length > 1 ||
        # If we're not on trello.com show the menu to make it easier to switch
        # A/B test configuration
        location.hostname != 'trello.com')
      escapedReturnUrl: escapedReturnUrl
      isEnterpriseAdmin: @model.isEnterpriseAdmin()
      upsellEnabled: !ClientConfig.get('dontUpsell')
      hasAppcuesNews: hasAppcuesNews

    @$el.html(headerUser(data))

    @renderUnreadNotifications()
    @renderAvatar()
    @renderMemberName()

    @

  renderMemberName: ->
    @$('.js-member-name').text(
      @model.get('fullName') ? @model.get('username')
    )

  renderAvatar: ->
    log('render', "rendering avatar")

    @$('.member').html(memberTemplate(@model.toJSON()))

    @

  renderUnreadNotifications: ->
    unreadNotifications = @model.unreadNotifications(@modelCache)
    showCount = getExperiment('cardNotifications').get('showCards') \
      && getExperiment('bellCount').get('showCount')
    elem = @$ '.js-open-header-notifications-menu'

    if showCount
      elem
        .toggleClass('display-dot', !unreadNotifications?)
        .toggleClass('display-count', unreadNotifications > 0)
        .attr('data-count', unreadNotifications)

    elem
      .toggleClass('new-notifications', unreadNotifications > 0)
      .toggleClass('other-notifications',
        unreadNotifications == 0 \
          && (@model.shouldShowSurvey() || @model.shouldShowMarketingOptIn())
      )

    # Tell the controller to update the title, to reflect the new unread count
    Controller.title()

    @

  updateLastSeen: ->
    # They have the notifications dialog open and the count
    # has been updated somewhere so lets also update the last
    # seen count so that the bell count is kept in sync.
    if Dialog.isVisible && \
       Dialog.displayType? && \
       Dialog.displayType.indexOf('mod-notifications') >= 0
      @model.notificationsSeenState.setLastSeen()

  viewAppcuesMenu: (e) ->
    appcuesItem = @appcuesItems.find((item) -> !item.seen) ? @appcuesItems[0]
    if !appcuesItem
      @viewInfoMenu(e)
      return

    track("Header", "Appcues Menu", "Open Appcues Menu")
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-open-header-appcues-menu')
      reactElement: React.createElement HeaderAppcuesPopOverComponent,
        appcuesItem: appcuesItem
        key: "header-appcues-pop-over-view-#{ appcuesItem.id }"
      getViewTitle: -> l(['view title', 'tips'])
      hidden: -> if !appcuesItem.seen then appcuesItem.markSeen()

    return

  viewInspirationPage: (e) ->
    track("Header", "Inspiration Page", "Open Information Page")
    Util.stop(e)
    window.open '/inspiration'
    return

  viewInfoMenu: (e) ->
    if e.altKey
      # trick for viewing already-seen or opted-out-of Appcues announcements
      MemberState.setAppcuesOptOut(false)
      for item in @appcuesItems when item.seen
        item.clearSeen()
      return

    track("Header", "Information Menu", "Open Information Menu")
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-open-header-info-menu')
      view: HeaderInfoMenuView
      maxWidth: 360
      options:
        model: @model
        modelCache: @modelCache

    return

  viewEnterpriseDashboardMenu: (e) ->
    Util.stop(e)

    track("Header", "Enterprise Dashboard Menu", "Open Enterprise Dashboard Menu")

    view = new HeaderEnterpriseAdminDashboardMenuView({ model: Auth.me(), @modelCache })

    PopOver.toggle
      elem: @$('.js-open-enterprise-dashboard-menu')
      view: view

    return

  viewNotificationsMenu: (e) ->
    Util.stop(e)

    if $('.mod-notifications').length
      track("Header", "Notifications Menu", "Close Notifications Menu")
    else
      track("Header", "Notifications Menu", "Open Notifications Menu", @model.unreadNotifications()?.count)

    if @model.shouldShowSurvey()
      @model.trackShowSurvey()

    hideFn = if getExperiment('cardNotifications').get('showCards') \
      then ->
      else _.bind @model.clearAllNotifications, @model

    isShowCards = getExperiment('cardNotifications').get('showCards')

    if Dialog.isVisible
      Dialog.hide()
      return

    Dialog.show
      elem: @$('.js-open-header-notifications-menu')
      hide: hideFn
      maxWidth: if isShowCards then 420 else 450
      displayType: if isShowCards then 'mod-notifications mod-cards' else 'mod-notifications'
      opacity: 0
      closeOnBlur: true
      hardToClose: false
      onScrollInner: -> PopOver.hide()
      reactElement: React.createElement HeaderNotificationListView,
        key: 'header-notifications'
        member: @model,
        markAllRead: _.bind @model.clearAllNotifications, @model
        showSurvey: @model.shouldShowSurvey(),
        showMarketingOptIn: @model.shouldShowMarketingOptIn(),
        onDismissSurvey: =>
          @model.dismissSurvey()
        submitSurvey: (surveyData) =>
          @model.submitSurvey(surveyData)
        setMarketingOptIn: (optedIn) =>
          @model.setMarketingOptIn(optedIn)
      options:
        model: @model
        modelCache: @modelCache

    return

  preloadCreateBoardData: (e) ->
    createBoardHelpers.preloadData()

  openAddMenu: (e) ->
    Util.stop(e)

    track("Header", "Add Menu", "Open")

    PopOver.toggle
      elem: @$('.js-open-add-menu')
      view: new HeaderAddMenuView({ model: Auth.me(), @modelCache })

    return

  viewMemberMenu: (e) ->
    Util.stop(e)

    track("Header", "User Menu", "Open User Menu")
    view = new HeaderMemberMenuView({ model: Auth.me(), @modelCache })

    PopOver.toggle
      elem: @$('.js-open-header-member-menu')
      view: view

    return

  viewChannelPicker: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: @$('.js-open-channel-picker')
      view: new HeaderChannelPicker({ model: Auth.me(), @modelCache })

    return



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-member-view.coffee